import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';
import { extractApiErrorMessage } from 'src/app/shared/utils/extract-api-error-message.util';
import { SupportService } from 'src/app/support.service';
import { Warehouse } from 'src/typings';
import { WarehouseService } from '../warehouse.service';

@Component({
  selector: 'app-warehouse-manager',
  templateUrl: './warehouse-manager.component.html',
  styleUrls: ['./warehouse-manager.component.scss']
})
export class WarehouseManagerComponent implements OnInit {
  warehouses: Warehouse[] = [];

  displayedColumns = ['id', 'description', 'city', 'inventoryValue', 'actions'];

  searchControl = new UntypedFormControl('');

  loading = false;

  deletingId?: number;

  constructor(
    private warehouseService: WarehouseService,
    private notificationService: NotificationService,
    private router: Router,
    public supportService: SupportService
  ) {}

  ngOnInit(): void {
    this.loadWarehouses();
  }

  get filteredWarehouses() {
    const query = String(this.searchControl.value || '')
      .trim()
      .toLowerCase();

    if (!query) return this.warehouses;

    return this.warehouses.filter((warehouse) => {
      const city = warehouse.city?.description || '';
      return (
        String(warehouse.id).includes(query) ||
        warehouse.description.toLowerCase().includes(query) ||
        city.toLowerCase().includes(query)
      );
    });
  }

  startCreate() {
    this.router.navigateByUrl('/warehouse/create');
  }

  startEdit(warehouse: Warehouse) {
    this.router.navigate(['/warehouse/edit', warehouse.id]);
  }

  remove(warehouse: Warehouse) {
    if (
      !window.confirm(
        `Удалить склад "${warehouse.description}"? Склад с привязанными документами или остатками удалить не получится.`
      )
    ) {
      return;
    }

    this.deletingId = warehouse.id;
    this.warehouseService
      .delete(warehouse.id)
      .pipe(finalize(() => (this.deletingId = undefined)))
      .subscribe(
        () => {
          this.notificationService.notice(`Склад "${warehouse.description}" удален`);
          this.loadWarehouses();
        },
        (error) => {
          this.notificationService.warning(
            extractApiErrorMessage(error, 'Не удалось удалить склад')
          );
        }
      );
  }

  private loadWarehouses() {
    this.loading = true;
    this.warehouseService
      .getManagementList()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        (warehouses) => {
          this.warehouses = [...warehouses].sort((left, right) =>
            left.description.localeCompare(right.description, 'ru')
          );
        },
        (error) => {
          this.notificationService.warning(
            extractApiErrorMessage(error, 'Не удалось загрузить склады')
          );
        }
      );
  }
}
